import { render, staticRenderFns } from "./ScoreRenderer.vue?vue&type=template&id=6ec66fd8&scoped=true&"
import script from "./ScoreRenderer.vue?vue&type=script&lang=js&"
export * from "./ScoreRenderer.vue?vue&type=script&lang=js&"
import style0 from "./ScoreRenderer.vue?vue&type=style&index=0&id=6ec66fd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec66fd8",
  null
  
)

export default component.exports